import { useEffect } from "react";
import InputFactory from "../../../../components/InputFactory";
import { getAllYears } from "./utils";

function Filters({ year, onChange, onFilter }) {
  const _onChange = (value, field) => {
    onChange({ [field]: value });
  };

  useEffect(() => {
    if (year != null && year !== "") {
      onFilter();
    }
  }, [year]);

  return (
    <>
      <div className="d-flex my-2 col-12">
        <div className="row g-2 align-items-md-center col-12 col-md-10 col-lg-8">
          <div className="col-12 col-md-auto d-flex align-items-center">
            <b>Year:</b>
          </div>
          <div className="col-12 col-md d-flex flex-column flex-md-row gap-2">
            <InputFactory
              type="Enum"
              options={getAllYears()}
              defaultValue={`${year}`}
              className="bg-white"
              placeholder="Select Year"
              field="year"
              onChange={_onChange}
              required
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Filters;
